// JS
import '../../custom/js/custom/index';

// JS Components
import '../../custom/js/custom/pagebuilder';
import '../../custom/js/custom/components/recipe-detail';

// Base SCSS
import '../../custom/scss/common/base.scss';
import '../../custom/scss/custom/layout.scss';

// Components SCSS
import '../../custom/scss/custom/page-builder.scss';
import '../../custom/scss/custom/components/read-more/read-more.scss';
import '../../custom/scss/custom/components/card/card.scss';
import '../../custom/scss/custom/components/recipe-detail-hero/recipe-detail-hero.scss';

// Other SCSS

import '../../custom/scss/custom/components/recipe-detail/recipe-detail.scss';